import { useState } from 'react';
import { CheckpointCelebrationVideo } from 'src/apps/QuickReview/celebrationVideos';
import { selectNextCelebrationVideo } from 'src/apps/QuickReview/celebrationVideoCycle';
import { getLocalStorageEntry } from 'src/utils/webStorageUtils';
import { TARGET_LANGUAGE } from 'src/utils/language/saveLastLanguagePair';

export const useEosCelebrationVideo = (): CheckpointCelebrationVideo | undefined => {
  const [video] = useState<CheckpointCelebrationVideo | undefined>(() =>
    selectNextCelebrationVideo(getLocalStorageEntry(TARGET_LANGUAGE)),
  );

  return video;
};
